import Quotes from "./quotes"

export default Quotes
